function getThemeFromCookie() {
  const match = document.cookie.match(/theme=([^;]+)/);
  return match ? match[1] : null;
}

export function initTheme() {
  const savedLocal = localStorage.getItem("theme");
  const savedCookie = getThemeFromCookie();

  const theme = savedLocal || savedCookie || "light";

  document.documentElement.setAttribute("data-theme", theme);

  localStorage.setItem("theme", theme);
  document.cookie = `theme=${theme}; path=/`;
}

export function toggleTheme() {
  const html = document.documentElement;

  const current = html.getAttribute("data-theme");
  const next = current === "dark" ? "light" : "dark";

  html.setAttribute("data-theme", next);

  localStorage.setItem("theme", next);
  document.cookie = `theme=${next}; path=/`;

  window.dispatchEvent(new Event("theme-change"));
}

export function getTheme() {
  return document.documentElement.getAttribute("data-theme");
}

export function getThemeIcon(lightIcon, darkIcon) {
  const theme = document.documentElement.getAttribute("data-theme");
  return theme === "dark" ? darkIcon : lightIcon;
}
